import { render } from "./KubernetesIntro.vue?vue&type=template&id=a74c4b92"
import script from "./KubernetesIntro.vue?vue&type=script&lang=js"
export * from "./KubernetesIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__